'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CREATE_BOOKING = exports.CREATE_BOOKING = 'redux-frontend/booking/CREATE_BOOKING';
var CREATE_BOOKING_SUCCESS = exports.CREATE_BOOKING_SUCCESS = 'redux-frontend/booking/CREATE_BOOKING_SUCCESS';
var CREATE_BOOKING_FAIL = exports.CREATE_BOOKING_FAIL = 'redux-frontend/booking/CREATE_BOOKING_FAIL';

var CLEAR_NOTI = exports.CLEAR_NOTI = 'redux-frontend/booking/CLEAR_NOTI';
var CLEAR_NOTI_SUCCESS = exports.CLEAR_NOTI_SUCCESS = 'redux-frontend/booking/CLEAR_NOTI_SUCCESS';
var CLEAR_NOTI_FAIL = exports.CLEAR_NOTI_FAIL = 'redux-frontend/booking/CLEAR_NOTI_FAIL';

// export const SET_BOOKING_DATA = 'redux-frontend/booking/SET_BOOKING_DATA';

var SET_PAYMENT = exports.SET_PAYMENT = 'redux-frontend/booking/SET_PAYMENT';
var SET_PAYMENT_SUCCESS = exports.SET_PAYMENT_SUCCESS = 'redux-frontend/booking/SET_PAYMENT_SUCCESS';
var SET_PAYMENT_FAIL = exports.SET_PAYMENT_FAIL = 'redux-frontend/booking/SET_PAYMENT_FAIL';

var SET_MAKING_PAYMENT = exports.SET_MAKING_PAYMENT = 'redux-frontend/booking/SET_MAKING_PAYMENT';

var GET_CARDS = exports.GET_CARDS = 'redux-frontend/booking/GET_CARDS';
var GET_CARDS_SUCCESS = exports.GET_CARDS_SUCCESS = 'redux-frontend/booking/GET_CARDS_SUCCESS';
var GET_CARDS_FAIL = exports.GET_CARDS_FAIL = 'redux-frontend/booking/GET_CARDS_FAIL';

var GET_BOOKING_DATA = exports.GET_BOOKING_DATA = 'redux-frontend/booking/GET_BOOKING_DATA';
var GET_BOOKING_DATA_SUCCESS = exports.GET_BOOKING_DATA_SUCCESS = 'redux-frontend/booking/GET_BOOKING_DATA_SUCCESS';
var GET_BOOKING_DATA_FAIL = exports.GET_BOOKING_DATA_FAIL = 'redux-frontend/booking/GET_BOOKING_DATA_FAIL';

var ACTIVATE_BOOKING = exports.ACTIVATE_BOOKING = 'redux-frontend/booking/ACTIVATE_BOOKING';
var ACTIVATE_BOOKING_SUCCESS = exports.ACTIVATE_BOOKING_SUCCESS = 'redux-frontend/booking/ACTIVATE_BOOKING_SUCCESS';
var ACTIVATE_BOOKING_FAIL = exports.ACTIVATE_BOOKING_FAIL = 'redux-frontend/booking/ACTIVATE_BOOKING_FAIL';

var SEND_MESSAGE = exports.SEND_MESSAGE = 'redux-frontend/booking/SEND_MESSAGE';
var SEND_MESSAGE_SUCCESS = exports.SEND_MESSAGE_SUCCESS = 'redux-frontend/booking/SEND_MESSAGE_SUCCESS';
var SEND_MESSAGE_FAIL = exports.SEND_MESSAGE_FAIL = 'redux-frontend/booking/SEND_MESSAGE_FAIL';

var UPDATE_BOOKING = exports.UPDATE_BOOKING = 'redux-frontend/booking/UPDATE_BOOKING';
var UPDATE_BOOKING_SUCCESS = exports.UPDATE_BOOKING_SUCCESS = 'redux-frontend/booking/UPDATE_BOOKING_SUCCESS';
var UPDATE_BOOKING_FAIL = exports.UPDATE_BOOKING_FAIL = 'redux-frontend/booking/UPDATE_BOOKING_FAIL';

var CONFIRM_BOOKING = exports.CONFIRM_BOOKING = 'redux-frontend/booking/CONFIRM_BOOKING';
var CONFIRM_BOOKING_SUCCESS = exports.CONFIRM_BOOKING_SUCCESS = 'redux-frontend/booking/CONFIRM_BOOKING_SUCCESS';
var CONFIRM_BOOKING_FAIL = exports.CONFIRM_BOOKING_FAIL = 'redux-frontend/booking/CONFIRM_BOOKING_FAIL';

var CHECK_CANCEL = exports.CHECK_CANCEL = 'redux-frontend/booking/CHECK_CANCEL';
var CHECK_CANCEL_SUCCESS = exports.CHECK_CANCEL_SUCCESS = 'redux-frontend/booking/CHECK_CANCEL_SUCCESS';
var CHECK_CANCEL_FAIL = exports.CHECK_CANCEL_FAIL = 'redux-frontend/booking/CHECK_CANCEL_FAIL';

var OPEN_COLLIDE = exports.OPEN_COLLIDE = 'redux-frontend/booking/OPEN_COLLIDE';

var RESCHEDULE_BOOKING = exports.RESCHEDULE_BOOKING = 'redux-frontend/booking/RESCHEDULE_BOOKING';
var RESCHEDULE_BOOKING_SUCCESS = exports.RESCHEDULE_BOOKING_SUCCESS = 'redux-frontend/booking/RESCHEDULE_BOOKING_SUCCESS';
var RESCHEDULE_BOOKING_FAIL = exports.RESCHEDULE_BOOKING_FAIL = 'redux-frontend/booking/RESCHEDULE_BOOKING_FAIL';

var RESPOND_BOOKING = exports.RESPOND_BOOKING = 'redux-frontend/booking/RESPOND_BOOKING';
var RESPOND_BOOKING_SUCCESS = exports.RESPOND_BOOKING_SUCCESS = 'redux-frontend/booking/RESPOND_BOOKING_SUCCESS';
var RESPOND_BOOKING_FAIL = exports.RESPOND_BOOKING_FAIL = 'redux-frontend/booking/RESPOND_BOOKING_FAIL';

// export const APPLY_PROMO = 'redux-frontend/booking/APPLY_PROMO';
// export const APPLY_PROMO_SUCCESS = 'redux-frontend/booking/APPLY_PROMO_SUCCESS';
// export const APPLY_PROMO_FAIL = 'redux-frontend/booking/APPLY_PROMO_FAIL';

var SET_MEETING_POINT = exports.SET_MEETING_POINT = 'redux-frontend/booking/SET_MEETING_POINT';
var SET_MEETING_POINT_SUCCESS = exports.SET_MEETING_POINT_SUCCESS = 'redux-frontend/booking/SET_MEETING_POINT_SUCCESS';
var SET_MEETING_POINT_FAIL = exports.SET_MEETING_POINT_FAIL = 'redux-frontend/booking/SET_MEETING_POINT_FAIL';

var POST_REVIEW = exports.POST_REVIEW = 'redux-frontend/booking/POST_REVIEW';
var POST_REVIEW_SUCCESS = exports.POST_REVIEW_SUCCESS = 'redux-frontend/booking/POST_REVIEW_SUCCESS';
var POST_REVIEW_FAIL = exports.POST_REVIEW_FAIL = 'redux-frontend/booking/POST_REVIEW_FAIL';

var POST_EXTRA_REVIEW = exports.POST_EXTRA_REVIEW = 'redux-frontend/booking/POST_EXTRA_REVIEW';
var POST_EXTRA_REVIEW_SUCCESS = exports.POST_EXTRA_REVIEW_SUCCESS = 'redux-frontend/booking/POST_EXTRA_REVIEW_SUCCESS';
var POST_EXTRA_REVIEW_FAIL = exports.POST_EXTRA_REVIEW_FAIL = 'redux-frontend/booking/POST_EXTRA_REVIEW_FAIL';

var REPLY_REVIEW = exports.REPLY_REVIEW = 'redux-frontend/booking/REVIEW_REPLY';
var REPLY_REVIEW_SUCCESS = exports.REPLY_REVIEW_SUCCESS = 'redux-frontend/booking/REPLY_REVIEW_SUCCESS';
var REPLY_REVIEW_FAIL = exports.REPLY_REVIEW_FAIL = 'redux-frontend/booking/REPLY_REVIEW_FAIL';

var GET_MESSAGES = exports.GET_MESSAGES = 'redux-frontend/booking/GET_MESSAGES';
var GET_MESSAGES_SUCCESS = exports.GET_MESSAGES_SUCCESS = 'redux-frontend/booking/GET_MESSAGES_SUCCESS';
var GET_MESSAGES_FAIL = exports.GET_MESSAGES_FAIL = 'redux-frontend/booking/GET_MESSAGES_FAIL';

var GET_PRICES = exports.GET_PRICES = 'redux-frontend/booking/GET_PRICES';
var GET_PRICES_SUCCESS = exports.GET_PRICES_SUCCESS = 'redux-frontend/booking/GET_PRICES_SUCCESS';
var GET_PRICES_FAIL = exports.GET_PRICES_FAIL = 'redux-frontend/booking/GET_PRICES_FAIL';

var LOAD_SUGGESTED_TRIP = exports.LOAD_SUGGESTED_TRIP = 'redux-frontend/booking/LOAD_SUGGESTED_TRIP';
var LOAD_SUGGESTED_TRIP_SUCCESS = exports.LOAD_SUGGESTED_TRIP_SUCCESS = 'redux-frontend/booking/LOAD_SUGGESTED_TRIP_SUCCESS';
var LOAD_SUGGESTED_TRIP_FAIL = exports.LOAD_SUGGESTED_TRIP_FAIL = 'redux-frontend/booking/LOAD_SUGGESTED_TRIP_FAIL';

var REQUEST_SUGGESTED_TRIP = exports.REQUEST_SUGGESTED_TRIP = 'redux-frontend/booking/REQUEST_SUGGESTED_TRIP';
var REQUEST_SUGGESTED_TRIP_SUCCESS = exports.REQUEST_SUGGESTED_TRIP_SUCCESS = 'redux-frontend/booking/REQUEST_SUGGESTED_TRIP_SUCCESS';
var REQUEST_SUGGESTED_TRIP_FAIL = exports.REQUEST_SUGGESTED_TRIP_FAIL = 'redux-frontend/booking/REQUEST_SUGGESTED_TRIP_FAIL';

var REQUEST_SWAP_LX = exports.REQUEST_SWAP_LX = 'redux-frontend/booking/REQUEST_SWAP_LX';
var REQUEST_SWAP_LX_SUCCESS = exports.REQUEST_SWAP_LX_SUCCESS = 'redux-frontend/booking/REQUEST_SWAP_LX_SUCCESS';
var REQUEST_SWAP_LX_FAIL = exports.REQUEST_SWAP_LX_FAIL = 'redux-frontend/booking/REQUEST_SWAP_LX_FAIL';
var SET_SWAP_REQUESTED = exports.SET_SWAP_REQUESTED = 'redux-frontend/booking/SET_SWAP_REQUESTED';

var OPEN_SUGGESTED = exports.OPEN_SUGGESTED = 'redux-frontend/booking/OPEN_SUGGESTED';
var OPEN_SWAP_LX = exports.OPEN_SWAP_LX = 'redux-frontend/booking/OPEN_SWAP_LX';

var CLEAR_LOADING_DATA = exports.CLEAR_LOADING_DATA = 'redux-frontend/booking/CLEAR_LOADING_DATA';

var OPEN_DETAIL = exports.OPEN_DETAIL = 'redux-frontend/booking/OPEN_DETAIL';
var OPEN_CALENDAR = exports.OPEN_CALENDAR = 'redux-frontend/booking/OPEN_CALENDAR';

var PUSH_MESSAGE = exports.PUSH_MESSAGE = 'redux-frontend/booking/PUSH_MESSAGE';

var SET_NEWBOOKING = exports.SET_NEWBOOKING = 'redux-frontend/booking/SET_NEWBOOKING';

var SET_MESSAGE = exports.SET_MESSAGE = 'redux-frontend/booking/SET_MESSAGE';

var CHANGE_STEP = exports.CHANGE_STEP = 'redux-frontend/booking/CHANGE_STEP';

var SUBMIT_LX_CANCEL = exports.SUBMIT_LX_CANCEL = 'redux-frontend/booking/SUBMIT_LX_CANCEL';
var SUBMIT_LX_CANCEL_SUCCESS = exports.SUBMIT_LX_CANCEL_SUCCESS = 'redux-frontend/booking/SUBMIT_LX_CANCEL_SUCCESS';
var SUBMIT_LX_CANCEL_FAIL = exports.SUBMIT_LX_CANCEL_FAIL = 'redux-frontend/booking/SUBMIT_LX_CANCEL_FAIL';

var SUBMIT_PAYMENT_CODE = exports.SUBMIT_PAYMENT_CODE = 'redux-frontend/booking/SUBMIT_PAYMENT_CODE';
var SUBMIT_PAYMENT_CODE_SUCCESS = exports.SUBMIT_PAYMENT_CODE_SUCCESS = 'redux-frontend/booking/SUBMIT_PAYMENT_CODE_SUCCESS';
var SUBMIT_PAYMENT_CODE_FAIL = exports.SUBMIT_PAYMENT_CODE_FAIL = 'redux-frontend/booking/SUBMIT_PAYMENT_CODE_FAIL';

var UPLOAD_TRIP_IMAGE = exports.UPLOAD_TRIP_IMAGE = 'redux-frontend/booking/UPLOAD_TRIP_IMAGE';
var UPLOAD_TRIP_IMAGE_SUCCESS = exports.UPLOAD_TRIP_IMAGE_SUCCESS = 'redux-frontend/booking/UPLOAD_TRIP_IMAGE_SUCCESS';
var UPLOAD_TRIP_IMAGE_FAIL = exports.UPLOAD_TRIP_IMAGE_FAIL = 'redux-frontend/booking/UPLOAD_TRIP_IMAGE_FAIL';

var RELEASE_PAYMENT = exports.RELEASE_PAYMENT = 'redux-frontend/booking/RELEASE_PAYMENT';
var RELEASE_PAYMENT_SUCCESS = exports.RELEASE_PAYMENT_SUCCESS = 'redux-frontend/booking/RELEASE_PAYMENT_SUCCESS';
var RELEASE_PAYMENT_FAIL = exports.RELEASE_PAYMENT_FAIL = 'redux-frontend/booking/RELEASE_PAYMENT_FAIL';

var HOLD_PAYMENT = exports.HOLD_PAYMENT = 'redux-frontend/booking/HOLD_PAYMENT';
var HOLD_PAYMENT_SUCCESS = exports.HOLD_PAYMENT_SUCCESS = 'redux-frontend/booking/HOLD_PAYMENT_SUCCESS';
var HOLD_PAYMENT_FAIL = exports.HOLD_PAYMENT_FAIL = 'redux-frontend/booking/HOLD_PAYMENT_FAIL';

var LOG_BOOKING_ACTION = exports.LOG_BOOKING_ACTION = 'redux-frontend/booking/LOG_BOOKING_ACTION';

var LOG_CLICK_BOOK_NOW_AND_SAVE = exports.LOG_CLICK_BOOK_NOW_AND_SAVE = 'redux-frontend/booking/LOG_CLICK_BOOK_NOW_AND_SAVE';

var OPEN_LX_HOTEL_PICKUP = exports.OPEN_LX_HOTEL_PICKUP = 'redux-frontend/booking/OPEN_LX_HOTEL_PICKUP';
var CLOSE_LX_HOTEL_PICKUP = exports.CLOSE_LX_HOTEL_PICKUP = 'redux-frontend/booking/CLOSE_LX_HOTEL_PICKUP';

var LX_ACCEPT_HOTEL_PICKUP = exports.LX_ACCEPT_HOTEL_PICKUP = 'redux-frontend/booking/LX_ACCEPT_HOTEL_PICKUP';
var LX_ACCEPT_HOTEL_PICKUP_SUCCESS = exports.LX_ACCEPT_HOTEL_PICKUP_SUCCESS = 'redux-frontend/booking/LX_ACCEPT_HOTEL_PICKUP_SUCCESS';
var LX_ACCEPT_HOTEL_PICKUP_FAIL = exports.LX_ACCEPT_HOTEL_PICKUP_FAIL = 'redux-frontend/booking/LX_ACCEPT_HOTEL_PICKUP_FAIL';

var OPEN_LX_STREET_FOOD = exports.OPEN_LX_STREET_FOOD = 'redux-frontend/booking/OPEN_LX_STREET_FOOD';
var CLOSE_LX_STREET_FOOD = exports.CLOSE_LX_STREET_FOOD = 'redux-frontend/booking/CLOSE_LX_STREET_FOOD';

var LX_ACCEPT_STREET_FOOD = exports.LX_ACCEPT_STREET_FOOD = 'redux-frontend/booking/LX_ACCEPT_STREET_FOOD';
var LX_ACCEPT_STREET_FOOD_SUCCESS = exports.LX_ACCEPT_STREET_FOOD_SUCCESS = 'redux-frontend/booking/LX_ACCEPT_STREET_FOOD_SUCCESS';
var LX_ACCEPT_STREET_FOOD_FAIL = exports.LX_ACCEPT_STREET_FOOD_FAIL = 'redux-frontend/booking/LX_ACCEPT_STREET_FOOD_FAIL';

var LX_OPEN_PROPOSE_NEW_DATE_MODAL = exports.LX_OPEN_PROPOSE_NEW_DATE_MODAL = 'redux-frontend/booking/LX_OPEN_PROPOSE_NEW_DATE_MODAL';
var LX_CLOSE_PROPOSE_NEW_DATE_MODAL = exports.LX_CLOSE_PROPOSE_NEW_DATE_MODAL = 'redux-frontend/booking/LX_CLOSE_PROPOSE_NEW_DATE_MODAL';

var NOTIFY_WORRY_FREE_BOOKING = exports.NOTIFY_WORRY_FREE_BOOKING = 'redux-frontend/booking/NOTIFY_WORRY_FREE_BOOKING';
var NOTIFY_WORRY_FREE_BOOKING_SUCCESS = exports.NOTIFY_WORRY_FREE_BOOKING_SUCCESS = 'redux-frontend/booking/NOTIFY_WORRY_FREE_BOOKING_SUCCESS';
var NOTIFY_WORRY_FREE_BOOKING_FAIL = exports.NOTIFY_WORRY_FREE_BOOKING_FAIL = 'redux-frontend/booking/NOTIFY_WORRY_FREE_BOOKING_FAIL';


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/booking/constant.js
// module id = 322
// module chunks = 47